var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradeAccepted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 0.500037C13.9706 0.500037 18 4.52948 18 9.50002C18 14.4706 13.9706 18.5 9.00002 18.5C4.02948 18.5 3.73308e-05 14.4706 3.73308e-05 9.50002C-0.014106 4.54357 3.99238 0.51418 8.94878 0.500037C8.96586 0.499988 8.98294 0.499988 9.00002 0.500037Z",
    fill: "#16A02C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4 13.625C5.1525 13.625 4.94063 13.5352 4.76438 13.3557C4.58812 13.1762 4.5 12.9604 4.5 12.7083V6.29167C4.5 6.03958 4.58812 5.82378 4.76438 5.64427C4.94063 5.46476 5.1525 5.375 5.4 5.375H12.6C12.8475 5.375 13.0594 5.46476 13.2356 5.64427C13.4119 5.82378 13.5 6.03958 13.5 6.29167V12.7083C13.5 12.9604 13.4119 13.1762 13.2356 13.3557C13.0594 13.5352 12.8475 13.625 12.6 13.625H5.4ZM5.85 11.7917H8.1V10.875H5.85V11.7917ZM10.1475 10.875L12.375 8.60625L11.7338 7.95312L10.1475 9.58021L9.50625 8.92708L8.87625 9.58021L10.1475 10.875ZM5.85 9.95833H8.1V9.04167H5.85V9.95833ZM5.85 8.125H8.1V7.20833H5.85V8.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeAccepted);
export default __webpack_public_path__ + "static/media/trade_accepted.460607d03da29744688c398b25461783.svg";
export { ForwardRef as ReactComponent };